import React from 'react';
import type { OperationDefinitionDto, OperationRunDetailsDto, OperationRunDto, OperationScheduleDto } from '../../types';


export const formatDateTime = (value: string | null) => {
    if (!value) return '-';
    return new Date(value).toLocaleString('ru-RU');
};

export const formatDuration = (run: OperationRunDto | OperationRunDetailsDto) => {
    if (!run.startedAt || !run.completedAt) return '-';

    const startedAt = new Date(run.startedAt).getTime();
    const completedAt = new Date(run.completedAt).getTime();
    const seconds = Math.max(0, Math.round((completedAt - startedAt) / 1000));

    return `${seconds} сек.`;
};

export const parseJson = <T,>(value: string | null): T | null => {
    if (!value) return null;

    try {
        return JSON.parse(value) as T;
    } catch {
        return null;
    }
};

export const statusLabel: Record<string, string> = {
    Queued: 'В очереди',
    Running: 'Выполняется',
    Succeeded: 'Успешно',
    Failed: 'Ошибка'
};

export const triggerLabel: Record<string, string> = {
    Manual: 'Ручной',
    Scheduled: 'Плановый'
};

export const riskLabel: Record<string, string> = {
    Low: 'Низкий',
    Medium: 'Средний',
    High: 'Высокий'
};

export const domainLabel: Record<string, string> = {
    Catalog: 'Каталог',
    Integrations: 'Интеграции',
    Attributes: 'Атрибуты',
    System: 'Система'
};

export const parseRefreshInterval = (value: string | null) => {
    if (!value) return 3;

    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 3;
};

export const buildDefaultParametersJson = (definition: OperationDefinitionDto) => {
    if (definition.parameters.length === 0) return '{}';

    const defaults = definition.parameters.reduce<Record<string, unknown>>((result, parameter) => {
        if (parameter.defaultValue === null) return result;

        if (parameter.type === 'boolean') {
            result[parameter.name] = parameter.defaultValue.toLowerCase() === 'true';
        } else if (parameter.type === 'number') {
            const numericValue = Number(parameter.defaultValue);
            result[parameter.name] = Number.isFinite(numericValue) ? numericValue : parameter.defaultValue;
        } else {
            result[parameter.name] = parameter.defaultValue;
        }

        return result;
    }, {});

    return JSON.stringify(defaults, null, 2);
};

export const getDryRun = (parametersJson: string) => {
    const parameters = parseJson<Record<string, unknown>>(parametersJson);
    return parameters?.dryRun !== false;
};

export const setDryRunParameter = (parametersJson: string, dryRun: boolean) => {
    const parameters = parseJson<Record<string, unknown>>(parametersJson) ?? {};
    return JSON.stringify({ ...parameters, dryRun }, null, 2);
};

